import { useEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { InformacionPJ } from './pj/InformacionPJ';
import { DatosPJ } from './pj/DatosPJ';
import { Clientepj } from '../../models/ClientePj';
import * as generic from '../../components/Generico';
import { ClientePJService } from '../../service/ClientePJService';
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { InfEconomica } from './pj/InfEconomica';
import { SocAccPj } from './pj/SocAccPj';
import { PepPj } from './pj/PepPj';
import { OrigenLic } from './pj/OrigenLic';
import { InfoApliada } from './pj/InfoApliada';
import { Declaracion } from './pj/Declaracion';
import { useToken } from '../../components/useToken';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { FiltroMultiempresa } from '../../components/FiltroMultiempresa';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from '../../components/AnexosComponent';
import { useLazyParams } from '../../hooks/useLazyParams';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { TablaDinamica } from '../../components/TablaDinamica';
import { DialogInstrucciones } from '../../components/ui/DialogInstrucciones';

export const ClientePerJu = () => {

    const [catalogos, setCatalogos] = useState(null);
    const omodel = new Clientepj({ formularioMatriz: catalogos?.formularioMatriz });
    const model = omodel.model;
    const [permss, setPermss] = useState(null);
    const clientepjSrv = new ClientePJService();
    const [cliente, setCliente] = useState(null);
    const [dialogClientepj, setDialogClientepj] = useState(false);
    const toast = useRef(null);
    const { getPerss, getRol } = useToken();
    const [empresa, setEmpresa] = useState(null);
    const [siCliente, setSiCliente] = useState(false);
    const tablaEstado = useLazyParams({ modelo: model });
    const menuRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [dialogInstruccion, setDialogInstruccion] = useState(false);
    const [dialogSubir, setDialogSubir] = useState(false);
    const [urls, setUrls] = useState(null);
    const [soloLectura, setSoloLectura] = useState(false);
    const topRef = useRef(null);
    const [mostrarRegresarFlotante, setMostrarRegresarFlotante] = useState(false);

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/clientepj',
            urlDownload: 'ficha/clientepj/descarga',
            urlUpload: 'ficha/clientepj/store',
            udelete: 'ficha/clientepj/eliminar-anexo',
            uactual: 'ficha/clientepj/editar',
            uenviar: 'ficha/clientepj/enviar',
            uaprobar: 'ficha/clientepj/aprobar',
        });
        const permisosToken = getPerss();
        const esClienteNotificado = permisosToken !== undefined; // Si tiene perss en el token es notificado
        setSiCliente(esClienteNotificado);
        if (esClienteNotificado) {
            setPermss(permisosToken);
            editFicha(true);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const esClienteNotificado = getPerss() !== undefined;
        if (!esClienteNotificado) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    // Efecto para observar el inicio del formulario
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setMostrarRegresarFlotante(!entry.isIntersecting);
            },
            { threshold: 0 }
        );
        const currentRef = topRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [dialogClientepj]); // Dependencia clave: se re-ejecuta cuando abre/cierra el formulario

    const editFicha = (esNotificado = false, isReadOnly = false) => {
        setSoloLectura(isReadOnly);
        const idConsulta = esNotificado ? 0 : cliente?.id;
        const necesitaCatalogos = catalogos === null;
        clientepjSrv.consultarClientepj(idConsulta, null, { necesitaCatalogos: necesitaCatalogos }).then(res => {
            if (necesitaCatalogos && res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
            if (!res.data.clientepj) {
                iniciarNuevo();
                return;
            }

            setDialogClientepj(true);
            setActiveIndex(0);
            setDialogInstruccion(true);

            // Sincronizamos el estado principal con lo que necesitamos para navegar
            nuevoCliente({
                id: res.data.clientepj.id,
                nemonico: res.data.clientepj.nemonico
            });
        }).finally(() => {
            // Lógica final si es necesaria
        });
    }

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        delete _lazyParams.empresa;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (empresa) {
            _lazyParams.empresa = empresa;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            tablaEstado.setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        clientepjSrv.getClientepj({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);

            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    // FUNCIÓN VITAL. Actualiza el estado global del cliente actual en el formulario.
    const nuevoCliente = (nuevo) => {
        if (!nuevo) {
            setCliente(null);
            return;
        }
        setCliente(prev => ({ ...prev, ...nuevo }));
    }

    const iniciarNuevo = () => {
        setSoloLectura(false);
        setDialogClientepj(true);
        nuevoCliente(null);
        setActiveIndex(0);
        setDialogInstruccion(true);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteCliente()
        });
    }

    const deleteCliente = () => {
        clientepjSrv.eliminarClientepj(cliente?.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const regresar = () => {
        setActiveIndex(0);
        setDialogClientepj(false);
        setSoloLectura(false);
        if (!siCliente) {
            loadLazyData();
        }
    };

    const handleNext = () => {
        if (activeIndex < 7) {
            setActiveIndex(activeIndex + 1);
        }
    };

    const handlePrev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setCliente(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    // Menu del formulario Cliente Persona Jurídica
    const itemsMenu = () => {
        const items = [];
        if (permss?.consultar) {
            items.push({ label: 'Ver', icon: 'pi pi-eye', command: () => { editFicha(false, true) } });
        }
        if (permss?.actualizar && (cliente?.nemonico === 'BORRADOR' || cliente?.nemonico === 'ENVIADO')) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        }
        if (permss?.consultar) {
            items.push({ label: 'Anexos', icon: 'pi pi-folder-open', command: () => { setDialogSubir(true) } });
        }
        if (permss?.eliminar && cliente?.nemonico === 'BORRADOR') {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items: items }];
    };

    const reiniciar = () => {
        if (!siCliente) {
            loadLazyData();
        }
        setDialogClientepj(false);
        setDialogSubir(false);
    }

    const verificacion = (data) => {
        loadLazyData();
    }

    const panelHeaderTemplate = () => (
        <div className="p-panel-header flex justify-content-between align-items-center flex-wrap gap-2 w-full">
            <div>
                <h3 className="m-0 text-xl font-bold p-text-secondary flex align-items-center">
                    <i className="pi pi-building mr-2"></i>
                    <span className="mr-2">{soloLectura ? 'VER' : cliente?.id ? 'EDITAR' : 'NUEVO'} FORMULARIO DE INFORMACIÓN DE PERSONA JURÍDICA</span>
                    <Button type="button" icon="pi pi-question-circle" className="p-button-rounded p-button-text p-button-sm p-0 m-0 text-white hover:text-blue-200 transition-colors transition-duration-200"
                        style={{ width: '2rem', height: '2rem' }} onClick={() => setDialogInstruccion(true)} tooltip="Ver instrucciones" tooltipOptions={{ position: 'right' }} />
                </h3>
            </div>
            {!siCliente && (
                <Button tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} icon="pi pi-arrow-left" onClick={regresar} />
            )}
        </div>
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogClientepj && !siCliente && <div className="fadein animation-duration-300">
                {getRol() && getRol()?.ideg && <FiltroMultiempresa loadLazyData={loadLazyData} setEmpresa={setEmpresa} />}
                <Toolbar className="mb-4" start={(getRol() && getRol()?.ideg) ? null : generic.leftToolbarTemplate(iniciarNuevo, 'Nuevo', permss)}
                    end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Reporte_persona_juridica', 'LISTADO CLIENTES PERSONA JURIDICA')}></Toolbar>

                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
                </Card>
            </div>
            }
            {dialogClientepj &&
                <div className="fadein animation-duration-300">
                    <Panel headerTemplate={panelHeaderTemplate} className="panel-ficha shadow-2">
                        <div ref={topRef} style={{ position: 'absolute', top: '0', left: '0', width: '1px', height: '80px', pointerEvents: 'none', visibility: 'hidden' }} />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Sección 1" rightIcon="pi pi-address-book ml-2" disabled={!cliente?.id}>
                                <InformacionPJ toast={toast} siCliente={siCliente} next={handleNext} catalogos={catalogos} id={cliente?.id}
                                    nuevoCliente={nuevoCliente} permss={permss} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 2" disabled={!cliente?.id} rightIcon="pi pi-user ml-2">
                                <DatosPJ toast={toast} id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 3" disabled={!cliente?.id} rightIcon="pi pi-money-bill ml-2">
                                <InfEconomica toast={toast} id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 4" disabled={!cliente?.id} rightIcon="pi pi-warehouse ml-2">
                                <SocAccPj toast={toast} id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 5" disabled={!cliente?.id} rightIcon="pi pi-eye ml-2">
                                <PepPj toast={toast} id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 6" disabled={!cliente?.id} rightIcon="pi pi-shop ml-2">
                                <OrigenLic toast={toast} id={cliente?.id} catalogos={catalogos} back={handlePrev} next={handleNext} permss={permss} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 7" disabled={!cliente?.id} rightIcon="pi pi-building-columns ml-2">
                                <InfoApliada toast={toast} id={cliente?.id} back={handlePrev} next={handleNext} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                            </TabPanel>
                            <TabPanel header="Sección 8" disabled={!cliente?.id} rightIcon="pi pi-file ml-2">
                                <Declaracion toast={toast} id={cliente?.id} back={handlePrev} setDialogClientepj={setDialogClientepj} permss={permss} cancelar={getPerss() === undefined}
                                    setdialogIns={setDialogInstruccion} urls={urls} estado={cliente?.nemonico} reiniciar={reiniciar} soloLectura={soloLectura}
                                    tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} anexosRequisitosExtranjero={catalogos?.anexosRequisitosExtranjero}
                                    anexosRequisitosNacional={catalogos?.anexosRequisitosNacional} />
                            </TabPanel>
                        </TabView>
                    </Panel>

                    {mostrarRegresarFlotante && !siCliente && (
                        <div className="fadein scalein" style={{ position: 'fixed', top: '65px', right: '30px', zIndex: 999 }}>
                            <Button icon="pi pi-arrow-left" onClick={regresar} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} />
                        </div>
                    )}
                </div>
            }
            <DialogInstrucciones visible={dialogInstruccion} onHide={() => setDialogInstruccion(false)} title={omodel.titulo} items={omodel.pasosInstrucciones} />
            <Dialog visible={dialogSubir} header="Gestión de anexos" modal className="p-fluid modal-ssize" onHide={e => setDialogSubir(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="clientePj" urls={urls} idp={cliente?.id} toast={toast} permss={permss} setDialogSubir={setDialogSubir} reiniciar={reiniciar}
                    loadLazyData={loadLazyData} verificacion={verificacion} estado={cliente?.nemonico} />
            </Dialog>
        </>
    )
}
